function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject;
var _excluded = ["children", "className", "look", "size", "weight"],
  _excluded2 = ["look", "size", "weight"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { useContext } from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import "../../../../enums/accordion.js";
import { AlertLooks } from "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import "../../../../enums/font-icon.js";
import { FontSizes, FontWeights } from "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import { getInlineAlertTheme } from "../../../../styles/styled-components/alert.js";
import "../../../../styles/styled-components/animations.js";
import "../../../../styles/styled-components/box-shadow.js";
import "../../../../styles/styled-components/button.js";
import { getFontSize, getFontWeight } from "../../../../styles/styled-components/font.js";
import "../../../../styles/styled-components/font-face.js";
import "../../../../styles/styled-components/global.js";
import "../../../../themes/alert.js";
import "../../../../themes/button.js";
import "../../../../themes/checkbox.js";
import "../../../../themes/divider.js";
import "../../../../themes/dropdown.js";
import "../../../../themes/fieldset.js";
import "../../../../themes/input.js";
import "../../../../themes/list.js";
import "../../../../themes/listbox.js";
import "../../../../themes/loader.js";
import "../../../../themes/option.js";
import "../../../../themes/popout.js";
import "../../../../themes/switch.js";
import { lightTheme } from "../../../../themes/themes.js";
import "../../../../themes/tooltip.js";
import "../../../../styles/styled-components/input.js";
import "../../../../styles/styled-components/list.js";
import "../../../../styles/styled-components/listitem.js";
import "../../../../styles/styled-components/media-queries.js";
import "../../../../styles/styled-components/reset.js";
import "../../../../styles/styled-components/outline.js";
import "../../../../styles/styled-components/popout.js";
import "../../../../styles/styled-components/screen-reader.js";
import "../../../../styles/styled-components/switch.js";
import "../../../../styles/styled-components/tooltip.js";
import { BaseAlert } from "../base-alert/base-alert.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var BaseInlineAlert = function BaseInlineAlert(props) {
  var _classnames;
  var children = props.children,
    className = props.className,
    look = props.look,
    size = props.size,
    weight = props.weight,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(BaseAlert, _extends({}, otherProps, {
    className: classnames((_classnames = {
      'bf-alert__inline': true
    }, _defineProperty(_classnames, "bf-alert__inline--look-".concat(look), !!look), _defineProperty(_classnames, "bf-alert__inline--size-".concat(size), !!size), _defineProperty(_classnames, "bf-alert__inline--weight-".concat(weight), !!weight), _defineProperty(_classnames, "".concat(className), !!className), _classnames)),
    tag: "p"
  }), children);
};
var Alert = styled(BaseInlineAlert)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  display: block;\n  ", "\n  ", "\n  ", "\n"])), function (_ref) {
  var look = _ref.look;
  return getInlineAlertTheme({
    look: look
  });
}, function (_ref2) {
  var size = _ref2.size;
  return getFontSize({
    size: size
  });
}, function (_ref3) {
  var weight = _ref3.weight;
  return getFontWeight({
    weight: weight
  });
});
/**
 * A component to show validation errors to be used inline alongside form controls.
 * Both `children` text content and `id` are required props.
 *
 * A requirement to use this component is that the form control should have `aria-describedby="example"`
 * that matches the `id` prop of `<InlineAlert id="example">` (this links the elements together for screen readers).
 * Additionally, when invalid, the form control should also have the attribute `aria-invalid="true"`.
 *
 * `<InlineAlert>` has `role="alert"`, which is equivalent to setting `aria-live="assertive"` and `aria-atomic="true"`.
 * This means that validation errors will be announced to screen readers immediately when `<InlineAlert>`
 * appears in the DOM (such as submitting a form). If you are validating a form control while typing
 * (such as inputting an email address), set `AlertTypes.Polite` so that screen readers announce the error
 * after users are finished typing.
 *
 * https://www.w3.org/WAI/tutorials/forms/notifications/
 *
 * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/alert_role
 *
 * @param props InlineAlertProps
 * @returns FunctionComponent<InlineAlertProps>
 */
var InlineAlert = function InlineAlert(props) {
  var _props$look = props.look,
    look = _props$look === void 0 ? AlertLooks.Error : _props$look,
    _props$size = props.size,
    size = _props$size === void 0 ? FontSizes.XSmall : _props$size,
    _props$weight = props.weight,
    weight = _props$weight === void 0 ? FontWeights.Book : _props$weight,
    otherProps = _objectWithoutProperties(props, _excluded2);
  var themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeContext || lightTheme
  }, /*#__PURE__*/React.createElement(Alert, _extends({}, otherProps, {
    look: look,
    size: size,
    weight: weight
  })));
};
export { InlineAlert };